export default {
    methods: {
        saveToLocalStorage(...params) {
            const prefix = this.$options.name || 'defaultPrefix';
            const savedValues = JSON.parse(localStorage.getItem(`${prefix}_selectedValues`)) || {};
            params.forEach(param => {
                savedValues[param] = this[param];
            });
            localStorage.setItem(`${prefix}_selectedValues`, JSON.stringify(savedValues));
        },
        loadFromLocalStorage(...params) {
            const prefix = this.$options.name || 'defaultPrefix';
            const savedValues = JSON.parse(localStorage.getItem(`${prefix}_selectedValues`));
            if (savedValues) {
                params.forEach(param => {
                    if (savedValues[param] !== undefined) {
                        this[param] = savedValues[param];
                    }
                });
            }
        },
    },
};